import qs from 'qs';
import * as React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Status } from 'src/graphql/types';
import { getUserID } from '../../libs/auth/index';
import PageNotFound from '../page-not-found';
import { OrderDetailsPage } from './page';
import { PotentialOrderDetailsPage } from './potential-order-details-page';

export const ORDER_ID_PARAM = 'orderId';
export const ITEM_ID_PARAM = 'itemId';

export const ORDER_DETAILS_PAGE_ROUTE = '/order-details';
export const POTENTIAL_ORDER_DETAILS_PAGE_ROUTE = '/potential-order-details';

export interface IOrderDetailsPageParams {
  [ORDER_ID_PARAM]: string;
  [ITEM_ID_PARAM]?: string;
  status?: string;
  poId?: string;
}

export const orderDetailsRoute = (
  soldToId: string,
  params: IOrderDetailsPageParams,
  orderStatus?: string,
  shipToId?: string
) => {
  const queryString = qs.stringify(params, { addQueryPrefix: true });
  const uid = getUserID();
  return orderStatus === 'POTENTIAL'
    ? `${POTENTIAL_ORDER_DETAILS_PAGE_ROUTE}/${shipToId}${queryString}&uid=${uid}`
    : `${ORDER_DETAILS_PAGE_ROUTE}/${soldToId}${queryString}&uid=${uid}`;
};

const parseQueryString = (search: string): IOrderDetailsPageParams => {
  return qs.parse(search, {
    ignoreQueryPrefix: true,
  });
};

export function OrderDetailsRoute() {
  const { soldToId, orderStatus, shipToId } = useParams();
  const { search } = useLocation();
  const { orderId, itemId, status, poId } = parseQueryString(search);
  const statuses: Status[] =
    typeof status === 'string' ? (status.split(',') as Status[]) : [];

  if (shipToId && poId) {
    // if (shipToId) {
    return <PotentialOrderDetailsPage orderId={poId} shipToId={shipToId} />;
  }

  if (soldToId && orderId && itemId) {
    return (
      <OrderDetailsPage
        orderId={orderId}
        soldToId={soldToId}
        itemId={itemId}
        statuses={statuses}
      />
    );
  }

  if (soldToId && orderId) {
    return (
      <OrderDetailsPage
        orderId={orderId}
        soldToId={soldToId}
        statuses={statuses}
      />
    );
  }
  return <PageNotFound />;
}
